import API from "./authApi";

export const sendForgotOtp = (
  email
) =>
  API.post(
    "/auth/forgot-password/send-otp",
    { email }
  );

export const verifyForgotOtp = (
  email,
  otp
) =>
  API.post(
    "/auth/forgot-password/verify-otp",
    {
      email,
      otp,
    }
  );

export const resetPassword = (
  email,
  password
) =>
  API.post(
    "/auth/reset-password",
    {
      email,
      password,
    }
  );

export const changePassword = (
  currentPassword,
  newPassword
) =>
  API.post(
    "/auth/change-password",
    {
      currentPassword,
      newPassword,
    }
  );